export default {
  nav: {
    main: 'Peamine',
    ordersAndInvoices: 'Tellimused ja arved',
    drafts: 'Mustandid',
    automation: 'Automatiseerimine',
    workspace: 'Tööruum',
    templates: 'Mallid',
    delivery: 'Edastamine',
    settings: 'Seaded',
    shippingLabels: 'Saatelehed',
    subscriptions: 'Tellimused',
    support: 'Tugi',
    developer: 'Arendaja',
    writeReview: 'Kirjuta arvustus',
    supportTicket: 'Tugipäring',
    welcomeTour: 'Tervitustutvustus',
    administratorConsole: 'Administraatori konsool',
    logout: 'Logi välja',
  },
  dashboard: {
    pageTitle: 'Tellimused ja arved',
    pageDescription: 'Manage your orders and invoices',
    title: 'Tellimused ja arved',
    selectedOrders: '{count} valitud tellimust',
    completed: '% valmis',
    processing: 'Töötlemine, palun oodake...',
    bulkDownload: 'Hulgilaadimine',
    upgradeBulkDownload: 'Uuendage oma plaani hulgilaadimise jaoks',
    showFilters: 'Näita filtreid',
    hideFilters: 'Peida filtrid',
    creatingInvoices: 'Arvete loomine, palun oodake...',
    bulkCreateInvoices: 'Loo arved hulgi',
    cannotCreateAutopilot: 'Te ei saa käsitsi arveid luua, kui arveldusrežiim on automaatpiloodil.',
    exportInvoices: 'Ekspordi arved või tellimused',
    capturePayments: 'Kinnita maksed käsitsi',
    filterOrders: 'Filtreeri tellimusi',
    error: 'Hei, midagi läks valesti...',
    close: 'Sulge',
    chooseDate: 'Vali kuupäev',
    chooseIssueDate: 'Valige valitud arvete väljastamiskuupäev',
    cancel: 'Tühista',
    createInvoices: 'Loo arved',
    storno: 'Storno',
    bulkOrderCapture: 'Tellimuste hulgikinnitamine',
  },
  search: {
    createdBetween: 'Loodud vahemikus',
    modifiedBetween: 'Muudetud vahemikus',
    orderNumber: 'Tellimus #',
    invoiceNumber: 'Arve #',
    refundNumber: 'Tagasimakse #',
    customer: 'Klient',
    payment: 'Makse',
    any: 'Kõik',
    authorized: 'Autoriseeritud',
    pending: 'Ootel',
    paid: 'Makstud',
    partiallyPaid: 'Osaliselt makstud',
    refunded: 'Tagastatud',
    voided: 'Tühistatud',
    partiallyRefunded: 'Osaliselt tagastatud',
    unpaid: 'Maksmata',
    fulfillment: 'Täitmine',
    fulfilled: 'Saadetud',
    partial: 'Osaline',
    unfulfilled: 'Saatmata',
    loading: 'Tellimuste laadimine...',
    search: 'Otsi',
  },
  orderList: {
    noCustomer: 'Klient puudub',
    downloadOrder: 'Laadi tellimus alla',
    deleteWarning: 'Tähelepanu! See kustutab kõik arved ja tagasimaksed, mis on loodud pärast kuupäeva:',
    includingInvoice: 'sealhulgas valitud arve #',
    pressOk: 'Vajutage OK jätkamiseks või Tühista katkestamiseks.',
    cannotCreateAutopilot: 'Te ei saa käsitsi arveid luua, kui arveldusrežiim on automaatpiloodil.',
    createInvoice: 'Loo arve sellele tellimusele',
    create: 'Loo',
    addCreditNote: 'Lisa kreeditarve',
    createStorno: 'Loo stornoarve',
    refund: 'Tagasimakse',
    downloadInvoice: 'Laadi see arve alla',
    download: 'Laadi alla',
    default: 'Vaikimisi',
    downloadStorno: 'Laadi see storno/kreeditarve alla',
    fulfillOrder: 'Täida tellimus',
    orderNum: 'Tellimus #',
    locPrefix: 'Asukoha prefiks',
    invoiceNum: 'Arve #',
    refundNum: 'Tagasimakse #',
    customerCol: 'Klient',
    orderCreatedDate: 'Tellimuse loomise kuupäev',
    orderModifiedDate: 'Tellimuse muutmise kuupäev',
    delivered: 'Tarnitud',
    paymentStatus: 'Makse olek',
    fulfillmentStatus: 'Tarne staatus',
    totalOutstanding: 'Tasumata kogusumma',
    originalPrice: 'Algne hind',
    noOrders: 'Teie poel pole valitud olekuga tellimusi.',
    cannotCreateNoOrders: 'Te ei saa arveid luua, kui tellimusi pole.',
    createOrdersFirst: 'Palun looge vähemalt üks tellimus ja proovige uuesti.',
    createOrders: 'Loo tellimused',
    loadingOrders: 'Laadimine...',
    paidManual: 'Makstud - Käsitsi',
    paid: 'Makstud',
    refunded: 'Tagastatud',
    pending: 'Ootel',
    partiallyPaid: 'Osaliselt makstud',
    partiallyRefunded: 'Osaliselt tagastatud',
    fulfilled: 'Saadetud',
    unfulfilled: 'Saatmata',
    deliveryPending: 'Ootel',
    deliverNow: 'Toimeta kohe',
    deliveryPartial: 'Osaline',
    notDelivered: 'Toimetamata',
    deliverAgain: 'Toimeta uuesti',
    deliveryDetails: 'Toimetamise üksikasjad',
    deliveryFailed: 'Toimetamine ebaõnnestus',
    sent: 'Saadetud',
    failed: 'Ebaõnnestus',
    toLabel: 'Saaja',
    folderLabel: 'Kaust',
    open: 'Avatud',
    invoice: 'Arve',
    creditNote: 'Kreeditarve',
    stornoLabel: 'Storno',
    unknown: 'Teadmata',
    googleDrive: 'Google Drive',
    clientsTablet: 'Klientide tahvel',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-post',
    ftpChannel: 'FTP',
    revertToDate: 'Taasta sellele kuupäevale',
    add: 'Lisa',
    close: 'Sulge',
  },
  downloadDialog: {
    downloadType: 'Laadi alla {type}...',
    selectTemplate: 'Valige galeriist mall tellimuste, arvete, stornoarvete või kreeditarvete eksportimiseks.',
    getMoreTemplates: 'Hangi rohkem malle',
    createNewTemplate: 'Loo uus mall',
    allCreatedBetween: 'Kõik loodud {type} vahemikus',
    selectedType: 'Valitud {type}',
    and: 'ja',
    status: 'Olek',
    any: 'Kõik',
    open: 'Avatud',
    closed: 'Suletud',
    cancelled: 'Tühistatud',
    paymentStatus: 'Makse olek',
    fulfillmentStatus: 'Tarne staatus',
    fulfilled: 'Saadetud',
    partial: 'Osaline',
    unfulfilled: 'Saatmata',
    authorized: 'Autoriseeritud',
    pending: 'Ootel',
    paid: 'Makstud',
    partiallyPaid: 'Osaliselt makstud',
    refunded: 'Tagastatud',
    voided: 'Tühistatud',
    partiallyRefunded: 'Osaliselt tagastatud',
    unpaid: 'Maksmata',
    format: 'Formaat',
    forLocation: 'Asukoht',
    advancedOptions: 'Täpsemad valikud',
    exportHSCodes: 'Ekspordi laoseisu HS-koode (aeglasem)',
    noteChrome: 'Märkus: Optimaalseks allalaadimiseks soovitatakse Chrome ja reklaamiblokeerija keelamine.',
    downloadIndividually: 'Laadi alla üksikult',
    downloadGrouped: 'Laadi alla grupeeritult',
  },
  templates: {
    pageTitle: 'Mallid',
    pageDescription: 'Customize your invoice templates',
    title: 'Mallid',
    installTranslated: 'Paigalda tõlgitud mall',
    installTranslatedDesc: 'Valige teine keel, klõpsates sellel nupul.',
    createNew: 'Looge vajaduse korral uus mall',
    createNewDesc: 'Vajaduse korral klõpsake sellel nupul uue malli loomiseks.',
    customize: 'Kohanda malle',
    customizeDesc: 'Klõpsake vaikemallil selle kohandamiseks. Saate muuta logo, värve ja edasijõudnud kasutajad ka koodi.',
    defaultTemplate: 'Arve, storno ja kreeditarve (vaikimisi)',
    logo: 'Logo',
    colorPalette: 'Värvipalett',
    getColorPalettes: 'Hangi värvipalette',
    paperSize: 'Paberi suurus',
    format: 'Formaat',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orientatsioon',
    landscape: 'Rõhtpaigutus',
    portrait: 'Püstpaigutus',
    margin: 'Veeris (cm)',
    unsavedChanges: 'Salvestamata muudatused',
    discard: 'Loobu',
    save: 'Salvesta',
  },
  labels: {
    pageTitle: 'Saatelehed',
    pageDescription: 'Create and manage shipping labels',
    title: 'Saatelehed',
    glsRequiresPro: 'GLS saatelehed EEU jaoks nõuavad Professional plaani.',
    upgradeDesc: 'Uuendage Professional plaanile saatelehtede loomiseks ja haldamiseks.',
    upgradePlan: 'Uuendage oma plaani',
    eeuGls: 'EEU GLS',
    enabled: 'Lubatud',
    country: 'Riik',
    hungary: 'Ungari',
    slovakia: 'Slovakkia',
    czech: 'Tšehhi',
    romania: 'Rumeenia',
    slovenia: 'Sloveenia',
    croatia: 'Horvaatia',
    senderId: 'Saatja ID',
    username: 'Kasutajanimi',
    password: 'Parool',
    name: 'Nimi',
    city: 'Linn',
    address: 'Aadress',
    zipCode: 'Postiindeks',
    contactPerson: 'Kontaktisik',
    phone: 'Telefon',
    email: 'E-post',
    glsServices: 'GLS teenused',
    expressService: 'Kiirteenus',
    exchangeService: 'Vahetusteenus',
    smsService: 'SMS-teenus',
    smsText: 'SMS-tekst',
    preAdviceService: 'Eelteavitusteenus',
    unsavedChanges: 'Salvestamata muudatused',
    discard: 'Loobu',
    save: 'Salvesta',
  },
  billing: {
    pageTitle: 'Arveldamine',
    pageDescription: 'Manage your subscription and billing',
    title: 'Arveldamine',
    subscriptionFor: 'Tellimuse plaan poele',
    currentlySubscribed: 'Te olete praegu tellinud',
    plan: 'plaani',
    cancelSubscription: 'Tühista tellimus',
    upgradePlan: 'Uuendage oma plaani',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / kuu',
    upgrade: 'Uuenda',
    includesAllStarter: 'Sisaldab kõiki Starter funktsioone, pluss:',
    proFeature1: 'Globaalne vastavuskomplekt: asukohapõhised prefiksid ja kohandatud järjestikune nummerdamine',
    proFeature2: 'Nutikas lokaliseerimine: automaatselt tõlgitud e-kirjad ja lokaliseeritud PDF-manused',
    proFeature3: 'Täielik B2B dokumenditsükkel: proformad, B2B pakkumised ja kreeditarved',
    proFeature4: 'B2B raamatupidamise sünkroonimine: 3-kohaline ühikutäpsus ja mitmevaluuta kuvamine',
    proFeature5: 'Automaatsed varukoopiad: kopeerige arved automaatselt turvalisele FTP-le või Google Drive\'i',
    proFeature6: 'Shopify Flow: automatiseerige arvete loomist, edastamist ja stornot Flow päästikute ja toimingutega',
    proFeature7: 'Täiustatud tehisintellekti loogika: kasutage seadmesisest AI-d keeruliste tingimuslike paigutusklauslite jaoks',
    proFeature8: 'UBL XML ja ZUGFeRD / Factur-X eksport (Euroopa e-arvete vastavus)',
    proFeature9: 'EPC QR koodid kiireks mobiilseks POS-makseks',
    proFeature10: 'GLS saatelehed EEU jaoks',
    proFeature11: '7-aastane vastavus maksuandmete säilitamisele',
    currentlyUsing: 'Te kasutate praegu meie',
    free: 'tasuta',
    subscriptionPlan: 'tellimuse plaani.',
    monthlyUsage: 'Igakuine kasutus',
    monthlyGenerated: '{count} / 50 arvet sel kuul',
    monthlyLimitReached: 'Kuulimiit on täis. Uuendage Starter plaanile piiramatute arvete jaoks.',
    freePlan: 'Tasuta plaan',
    freeToInstall: 'Tasuta paigaldada',
    freeFeature1: 'Kuni 50 arvet/tellimust kuus',
    freeFeature2: 'Juurdepääs kõigile 31+ eelmääratletud mallile',
    freeFeature3: 'Põhiline AI Copilot',
    freeFeature4: 'Standardne PDF-allalaadimine ja printimine',
    freeFeature5: 'Standardne dokumendikomplekt (arved, saatelehed, kviitungid)',
    freeFeature6: '3-kuuline turvaline arvete säilitamine',
    starterPlan: 'Starter plaan',
    starterPrice: '$9.99 / kuu',
    starterPricePerInvoice: '+ 3¢ loodud arve kohta',
    subscribe: 'Telli',
    starterFeature1: 'Piiramatud arved ja tellimused',
    starterFeature2: 'Automaatne PDF-edastamine e-postiga',
    starterFeature3: 'Täielik juurdepääs hübriidredaktorile ja AI Copilotile',
    starterFeature4: 'Shopify POS ja vöötkoodide integratsioon',
    starterFeature5: 'Shopify Flow: päästikud ja toimingud arvete automatiseerimiseks',
    starterFeature6: 'UBL XML / PEPPOL ja ZUGFeRD / Factur-X eksport (e-arvete vastavus)',
    starterFeature7: '1-aastane turvaline arvete säilitamine',
    proTaxOverrides: 'Kohandatud maksuülekirjutused: KM / GST toote kohta ja SKU-taseme määrad',
    unsavedChanges: 'Salvestamata muudatused',
    discard: 'Loobu',
    save: 'Salvesta',
  },
  autopilot: {
    pageTitle: 'Automatiseerimine',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatiseerimine',
    autoCreate: 'Loo arved automaatselt',
    disabled: 'Keelatud (käsitsi)',
    whenCreated: 'Tellimuste loomisel',
    whenFulfilled: 'Tellimuste täitmisel',
    whenPaid: 'Tellimuste maksmisel',
    autoCreateDesc: 'Arved luuakse tellimuste loomise, täitmise või maksmise kuupäeval.',
    autoStorno: 'Storneerige arved automaatselt',
    whenCancelled: 'Tellimuste tühistamisel või tagastamisel',
    autoStornoDesc: 'Stornoarved luuakse tellimuste tühistamise või tagasimaksete loomise kuupäeval.',
    cannotAutoFree: 'Arvete automaatset loomist ei saa teostada tasuta plaaniga.',
    upgradePlan: 'Uuendage oma plaani',
    unsavedChanges: 'Salvestamata muudatused',
    discard: 'Loobu',
    save: 'Salvesta',
  },
  delivery: {
    pageTitle: 'Edastamine',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Edastamine',
    settings: 'Seaded',
    useOrderNumbers: 'Kasuta failidele tellimusnumbreid',
    sendIfCountry: 'Saada, kui arveldusaadressi riik on',
    countryCodesHint: 'Loetlege kõik riigikoodid semikooloniga eraldatult.',
    sendForTags: 'Saada klientidele, kellel on üks loetletud siltidest',
    tagsHint: 'Loetlege kõik sildid semikooloniga eraldatult.',
    emailDelivery: 'E-posti edastamine',
    sendAsPdf: 'Saada arved PDF-manustena klientidele',
    autoSend: 'Saada automaatselt arve loomisel',
    subject: 'Teema',
    body: 'Sisu',
    xmlAttachments: 'XML-manused',
    attachUbl: 'Lisa UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Lisa ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Saada testmeil',
    sending: 'Saatmine...',
    customSmtp: 'Kohandatud SMTP server',
    customSmtpDesc: 'Kasutage oma meiliserverit vaikimisi serveri asemel',
    enableSmtp: 'Luba kohandatud SMTP',
    smtpHost: 'SMTP host',
    port: 'Port',
    useSsl: 'Kasuta SSL/TLS-i',
    username: 'Kasutajanimi',
    password: 'Parool',
    fromEmail: 'Saatja e-post',
    fromName: 'Saatja nimi',
    shopifyLiquid: 'Shopify Liquid mall',
    pasteInto: 'Kleepige see oma',
    orderConfirmation: 'tellimuse kinnituse malli',
    toAddLink: 'sisse, et lisada allalaadimislink.',
    downloadInvoice: 'Laadige oma arve alla',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Saatke päringud ClientsTablet teenusesse arvete loomisel',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Saatke PDF-arved tollidokumentidena ShippyPro teenusesse EL-väliste riikide jaoks',
    ftpBackup: 'FTP/SFTP varukoopia',
    ftpDesc: 'Kopeerige arved automaatselt oma serverisse',
    enableFtp: 'Luba automaatne FTP varukoopia',
    host: 'Host',
    useSftp: 'Kasuta SFTP-d (turvaline)',
    destinationFolder: 'Sihtkaust',
    xmlFiles: 'XML-failid',
    includeUbl: 'Lisa UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Lisa ZUGFeRD / Factur-X XML',
    testConnection: 'Testi ühendust',
    testing: 'Testimine...',
    pro: 'PRO',
    upgradeFtp: 'Uuendage Professional plaanile, et automaatselt kopeerida arveid FTP/SFTP serverisse.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Sünkroonige arved automaatselt oma Drive\'i',
    connected: 'Ühendatud',
    disconnect: 'Katkesta ühendus',
    notWorking: 'Ei tööta? Minge',
    googlePermissions: 'Google\'i õigused',
    removeThenReconnect: 'eemaldage Invoice Browse ja ühendage uuesti.',
    connectGoogleDrive: 'Ühenda Google Drive',
    upgradeGoogleDrive: 'Uuendage Professional plaanile, et automaatselt sünkroonida arveid Google Drive\'i.',
    unsavedChanges: 'Salvestamata muudatused',
    discard: 'Loobu',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Salvesta',
  },
  bookkeeping: {
    pageTitle: 'Seaded',
    pageDescription: 'Configure your invoice settings',
    title: 'Seaded',
    owner: 'Omanik',
    email: 'Email',
    phone: 'Telefon',
    keepDifferentNumbering: 'Hoia iga tellimuse asukoha jaoks eraldi arvenumbrid',
    keepDifferentNumberingDisabled: 'Iga tellimuse asukoha jaoks eraldi arvenumbrite hoidmine ei ole teie plaaniga lubatud.',
    locationEmailDesc: 'See võimaldab teil saata e-kirju ja arveid tõlgituna vastavalt tellimuse asukohale: laduasukoht, tarne- või arveldusaadress',
    upgradePlan: 'Uuendage oma plaani',
    matchingCriteria: 'Sobivuskriteeriumid',
    locationId: 'Asukoha ID',
    shippingCountryCode: 'Tarneaadressi riigikood',
    billingCountryCode: 'Arveldusaadressi riigikood',
    matchLocationDesc: 'Sobitage asukoht tellimuse asukoha ID, tarne- või arveldusaadressi riigikoodi alusel.',
    companyInfo: 'Ettevõtte andmed',
    name: 'Nimi',
    website: 'Veebileht',
    registrationNumber: 'Registreerimisnumber',
    taxId: 'Maksukohustuslase number',
    addressSection: 'Aadress',
    streetName: 'Tänav',
    streetNumber: 'Majanumber',
    zip: 'Postiindeks',
    city: 'Linn',
    region: 'Piirkond',
    country: 'Riik',
    bankingInfo: 'Pangaandmed',
    bankName: 'Panga nimi',
    swift: 'Swift',
    currency: 'Valuuta',
    iban: 'IBAN',
    invoicing: 'Arveldamine',
    decimalPlaces: 'Kümnendkohad',
    invoicesPrefix: 'Arvete prefiks',
    currentInvoiceNumber: 'Praegune arve number',
    creditNotesPrefix: 'Kreeditarvete prefiks',
    currentCreditNoteNumber: 'Praegune kreeditarve number',
    lastInvoiceDate: 'Viimase arve kuupäev',
    noInvoicesYet: 'Arveid pole veel loodud.',
    confirmReverting: 'Süsteemi taastamise kinnitus',
    allInvoicesAfter: 'Kõik arved ja nende stornod, mis on väljastatud pärast',
    willBeRemoved: 'eemaldatakse. Kas jätkata süsteemi taastamisega?',
    cancel: 'Tühista',
    revert: 'Taasta',
    revertDesc: 'Süsteemi taastamine kustutab kõik pärast valitud kuupäeva loodud arved.',
    revertToDate: 'Taasta sellele kuupäevale',
    reverting: 'Süsteemi taastamine, palun oodake...',
    useOrderNumbering: 'Kasuta tellimuse nummerdamist',
    showVat: 'Näita KM-i arvetel',
    overrideTaxes: 'Kirjuta maksud üle',
    pricesIncludeTax: 'Hinnad sisaldavad maksu',
    productsTaxRate: 'Toodete maksumäär',
    shippingTaxRate: 'Tarne maksumäär',
    skusSeparated: 'SKU-d semikooloniga eraldatult',
    skusTaxRate: 'SKU-de maksumäär',
    useOrderDates: 'Kasuta arvete jaoks tellimuse loomise kuupäevi',
    convertCurrency: 'Teisenda hinnad valuutasse, milles klient maksab',
    unsavedChanges: 'Salvestamata muudatused',
    discard: 'Loobu',
    save: 'Salvesta',
  },
  drafts: {
    pageTitle: 'Mustandid',
    pageDescription: 'Manage your draft orders',
    title: 'Mustandid',
    download: 'Laadi alla',
    newDraft: 'Uus mustand',
    exporting: 'Eksportimine {status}%...',
    accessNotGranted: 'Mustandtellimuste juurdepääs pole antud. Palun',
    reLogin: 'logige uuesti sisse',
    toGrantPermissions: 'vajalike "Mustandtellimuste" õiguste andmiseks.',
    pushFailed: 'Shopify\'sse saatmine ebaõnnestus:',
    exportError: 'Ekspordi viga:',
    confirmDelete: 'Kas olete kindel, et soovite selle mustandi kustutada?',
    incompleteCustomer: 'Kliendiandmed on puudulikud:',
    pushWithoutCustomer: 'Mustand saadetakse Shopify\'sse ilma kliendiandmeteta. Kas jätkata?',
    customerNotInShopify: 'Seda klienti pole veel Shopify\'s olemas.',
    warnings: 'Hoiatused:',
    createCustomerAndPush: 'Kas luua klient Shopify\'s ja saata mustandtellimus?',
  },
  draftEdit: {
    number: "Number",
    prefix: "Prefiks",

    newDraft: 'Uus mustand',
    editDraft: 'Muuda mustandit',
    viewInShopify: 'Vaata Shopify\'s',
    back: 'Tagasi',
    createDraft: 'Loo mustand',
    saveChanges: 'Salvesta muudatused',
    documentType: 'Dokumendi tüüp',
    draftOrder: 'Mustandtellimus',
    quote: 'Pakkumine',
    proforma: 'Proforma',
    manualInvoice: 'Käsiarve',
    currency: 'Valuuta',
    expiryDate: 'Aegumiskuupäev',
    status: 'Olek',
    draft: 'Mustand',
    sent: 'Saadetud',
    accepted: 'Vastu võetud',
    customer: 'Klient',
    firstName: 'Eesnimi',
    lastName: 'Perekonnanimi',
    email: 'E-post',
    phone: 'Telefon',
    company: 'Ettevõte',
    taxId: 'Maksukohustuslase number',
    billingAddress: 'Arveldusaadress',
    address: 'Aadress',
    aptSuite: 'Korter/Büroo',
    city: 'Linn',
    province: 'Maakond',
    countryField: 'Riik',
    zip: 'Postiindeks',
    shippingAddress: 'Tarneaadress',
    sameAsBilling: 'Sama mis arveldusaadress',
    lineItems: 'Reaüksused',
    shipping: 'Tarne',
    shippingTitle: 'Pealkiri',
    shippingPlaceholder: 'nt Standardtarne',
    price: 'Hind',
    note: 'Märkus',
    notePlaceholder: 'Sisemine märkus või sõnum kliendile...',
    summary: 'Kokkuvõte',
    subtotal: 'Vahesumma',
    discounts: 'Allahindlused',
    tax: 'Maks',
    total: 'Kokku',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Sisestage oma poe aadress',
    loginWith: 'Logi sisse',
    createAccount: 'Loo uus konto',
    placeholder: 'teie-poe-nimi',
    shopRequired: 'Poe nimi on nõutud',
    login: 'Logi sisse',
    shopify: 'Shopify',
    terms: 'Tingimused',
    privacy: 'Privaatsuspoliitika',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Kas Invoice Browse meeldib?',
    description: 'Olete loonud oma esimesed arved! Kui leiate, et rakendus on kasulik, aitab kiire arvustus Shopify App Store\'is meid väga palju.',
    reward: 'Tänuks lähtestame teie igakuise kasutusloenduri 0-le',
    leaveReview: 'Jäta arvustus',
    maybeLater: 'Võib-olla hiljem',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Tere tulemast Invoice Browse\'i',
    welcomeContent: 'Lubage mul näidata, kuidas seda kasutada.',
    dashboardTitle: 'Töölaud',
    dashboardContent: 'Ekraan, mida näete, on peamine töölaud. Siit leiate kõik tellimused ja saate neid eksportida erinevatesse dokumenditüüpidesse nagu: arved, saatelehed ja muud.',
    automationTitle: 'Muutke oma elu lihtsamaks',
    automationContent: 'Lubage automatiseerimine arvete loomiseks, kui tellimused on makstud või tagastatud.',
    templatesTitle: 'Kohanda malle',
    templatesContent: 'Sisenege siia, et tõlkida oma malli, kohandada seda või luua uus.',
    deliveryTitle: 'Edastamine',
    deliveryContent: 'Seadistage meie rakendus automaatselt kopeerima loodud dokumente FTP-sse, Google Drive\'i või e-posti manustena.',
    settingsTitle: 'Seaded',
    settingsContent1: 'Kohandage ettevõtte telefoninumbrit, e-posti ja muid dokumentidel kasutatavaid välju.',
    settingsContent2: 'Muutke dokumendi algusnumbrit või kustutage pärast valitud kuupäeva loodud dokumendid.',
    settingsContent3: 'Kirjutage üle KM-määrad tarne ja toodete jaoks',
    settingsContent4: 'Muutke numbrite kümnendkohti',
    reviewTitle: 'Kirjuta arvustus',
    reviewContent: 'Toetage meie meeskonda hea arvustuse kirjutamisega!',
    tourTitle: 'Tervitustutvustus',
    tourContent: 'Hei, saate selle tutvustuse siit uuesti avada.',
    createDocTitle: 'Looge oma esimene dokument',
    createDocContent: 'Klõpsake nuppu Loo, et luua oma esimene dokument.',
    docNumberTitle: 'Dokumendi number',
    docNumberContent: 'Esimesele dokumendile on määratud number 1. Kui soovite alustada muu numbriga, saate seda muuta Seadetest.',
    downloadDocTitle: 'Laadi dokument alla',
    downloadDocContent: 'Klõpsake rippmenüül Laadi alla ja valige dokumendimall, et eksportida oma tellimus PDF-ina.',
  },
  common: {
    save: 'Salvesta',
    cancel: 'Tühista',
    close: 'Sulge',
    discard: 'Loobu',
    delete: 'Kustuta',
    edit: 'Muuda',
    create: 'Loo',
    loading: 'Laadimine...',
    unsavedChanges: 'Salvestamata muudatused',
    upgradePlan: 'Uuendage oma plaani',
  },
  languageSelector: {
    label: 'Keel',
    auto: 'Automaattuvastus',
  },
  draftList: {
    draftNum: 'Mustand #',
    shopifyId: 'Shopify ID',
    type: 'Tüüp',
    customer: 'Klient',
    total: 'Kokku',
    status: 'Olek',
    delivered: 'Tarnitud',
    date: 'Kuupäev',
    actions: 'Toimingud',
    noCustomer: 'Klient puudub',
    noDrafts: 'Mustandeid ega pakkumisi ei leitud.',
    loading: 'Laadimine...',
    download: 'Laadi alla',
    default: 'Vaikimisi',
    pending: 'Ootel',
    deliverNow: 'Tarni kohe',
    deliveryDetails: 'Tarne üksikasjad',
    sent: 'Saadetud',
    failed: 'Ebaõnnestus',
    deliverAgain: 'Tarni uuesti',
    partial: 'Osaline',
    notDelivered: 'Tarnimata',
    deliveryFailed: 'Tarne ebaõnnestus',
    unknown: 'Teadmata',
    edit: 'Muuda',
    send: 'Saada',
    pushToShopify: 'Saada Shopifysse',
    complete: 'Lõpeta',
    duplicate: 'Kopeeri',
    delete: 'Kustuta',
    quote: 'Pakkumine',
    proforma: 'Proforma',
    draftOrder: 'Mustandi tellimus',
    manualInvoice: 'Käsitsi arve',
  },
  draftSearch: {
    createdBtw: 'Loodud vahemikus',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: 'Klient',
    status: 'Olek',
    type: 'Tüüp',
    delivery: 'Tarne',
    any: 'Kõik',
    draft: 'Mustand',
    sent: 'Saadetud',
    accepted: 'Aktsepteeritud',
    expired: 'Aegunud',
    converted: 'Teisendatud',
    cancelled: 'Tühistatud',
    quote: 'Pakkumine',
    proforma: 'Proforma',
    draftOrder: 'Mustandi tellimus',
    manualInvoice: 'Käsitsi arve',
    delivered: 'Tarnitud',
    notDelivered: 'Tarnimata',
    pending: 'Ootel',
    search: 'Otsi',
  },
  draftDownload: {
    title: 'Laadi alla Mustand #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: 'Olek',
    documentType: 'Tüüp',
    any: 'Kõik',
    draft: 'Mustand',
    sent: 'Saadetud',
    accepted: 'Aktsepteeritud',
    expired: 'Aegunud',
    converted: 'Teisendatud',
    cancelled: 'Tühistatud',
    quote: 'Pakkumine',
    proforma: 'Proforma',
    draftOrder: 'Mustandi tellimus',
    manualInvoice: 'Käsitsi arve',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Paigalda uus mall',
    tabStyle: 'Stiil',
    tabContent: 'Sisu',
    tabTranslations: 'Tõlked',
    tabSettings: 'Seaded',
    tabCode: 'Kood',
    tabCopilot: 'AI Kopilot',
    logo: 'Logo',
    colorPalette: 'Värvipalett',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/et.js